const RentGuarantee = ({
    isEligible = null,
    isEnabled = null,
    isSecurityDepositWaived = null,
    isCostAddedToRent = null,
    zuid = '',
    cost = 30,
} = {}) => ({
    isEligible: Boolean(isEligible),
    isEnabled: Boolean(isEnabled),
    isSecurityDepositWaived: Boolean(isSecurityDepositWaived),
    isCostAddedToRent: Boolean(isCostAddedToRent),
    zuid: String(zuid),
    cost: Number(cost),
});

export default RentGuarantee;
